import type { QueryParams } from '../../../types/baseExplorerConfig';

/**
 * Applies the CFFDRS analysis preset to a fetchData params object.
 *
 * When active, the preset:
 *  - filters to hour=13 (1 PM NWT-local, the standard CFFDRS observation hour)
 *  - filters to ffmc > 0 (via ffmcMin=0; SQL is `ffmc IS NOT NULL AND ffmc > 0`)
 *  - sorts timestamp desc (today at top), overriding any user sort
 *
 * See issue #514. Pure function; existing hour/ffmcMin filters are replaced
 * (not duplicated) so consecutive activations remain idempotent.
 */
export interface AppliedPreset extends QueryParams {
  filters: NonNullable<QueryParams['filters']>;
  sort: NonNullable<QueryParams['sort']>;
}

export function applyCffdrsPreset(params: QueryParams, active: boolean): QueryParams | AppliedPreset {
  if (!active) return params;

  const incoming = params.filters ?? [];
  const filters: NonNullable<QueryParams['filters']> = incoming
    .filter((f) => f.field !== 'hour' && f.field !== 'ffmcMin')
    .concat([
      { field: 'hour', operator: 'eq', value: '13' },
      { field: 'ffmcMin', operator: 'eq', value: '0' },
    ]);

  const sort: NonNullable<QueryParams['sort']> = [{ field: 'timestamp', direction: 'desc' }];

  return { ...params, filters, sort };
}
